<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__is_active__in')"
      @clean="cleanComponentFilters(['filter__is_active__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as USER_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'UserCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: USER_TYPES.GENERIC.account.user.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...USER_TYPES.GENERIC.account.user.LIST.ACTIONS
    })
  }
}
</script>
